"use client";

import { cloneElement, isValidElement, type ReactElement } from "react";

import { cn } from "../../utils";
import { useBadgeRootContext } from "./context";
import { iconStyles } from "./style";

export type BadgeIconProps = {
  children: ReactElement<{ className?: string }>;
  size?: "xs" | "sm" | "md" | "lg";
};

export const Icon = ({ children, size }: BadgeIconProps) => {
  const { size: rootSize } = useBadgeRootContext();
  if (!isValidElement(children)) {
    return children;
  }

  return cloneElement(children, {
    className: cn(iconStyles({ size: size || rootSize }), children.props.className),
  });
};
